import React from 'react'
import { OnboardTitle, OnboardSubtitle, AnimatedCheck } from 'components/Antifraude'
import { EmailOutlined } from '@mui/icons-material/'

import styles from './styles'

const EmailSent = () => {
  const classes = styles()

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.titleBar}>
          <div className={classes.locker}>
            <EmailOutlined fontSize="inherit" />
          </div>
          <OnboardTitle>E-mail enviado</OnboardTitle>
          <OnboardSubtitle>
            Um email de recuperação foi enviado para sua conta com
            instruções para a recuperação do seu acesso.
          </OnboardSubtitle>
        </div>
        <AnimatedCheck/>
      </div>
    </div>
  )
}

export default EmailSent
